import type { Theme } from "@c15t/react";

export const consentTheme = {
  colors: {
    border: "var(--border)",
    borderHover: "var(--border)",
    overlay: "color-mix(in oklab, var(--foreground) 40%, transparent)",
    primary: "var(--primary)",
    primaryHover: "var(--primary)",
    surface: "var(--card)",
    surfaceHover: "var(--muted)",
    switchThumb: "var(--background)",
    switchTrack: "var(--muted)",
    switchTrackActive: "var(--primary)",
    text: "var(--foreground)",
    textMuted: "var(--muted-foreground)",
    textOnPrimary: "var(--primary-foreground)",
  },
  radius: {
    lg: "calc(var(--radius) + 4px)",
    md: "var(--radius)",
  },
  shadows: {
    lg: "var(--shadow-lg)",
    md: "var(--shadow)",
  },
  /*
   * Below `sm` the stock banner stacked a title, a three-line description and
   * two rows of 36px buttons into 274px — the bottom third of a 375×812 phone,
   * sitting on top of the hero's second CTA. The mobile rules below fold it
   * into one text block and one row of buttons.
   *
   * c15t ships its CSS in `@layer components`, which Tailwind's `utilities`
   * layer outranks, so these slot classes win without `!important`.
   *
   * Reject and Accept keep identical size and styling on purpose: under the
   * GDPR guidance on consent, refusing has to be as easy as accepting, so
   * compacting the banner must never demote the reject action.
   */
  slots: {
    buttonPrimary: "font-medium",
    consentBanner: "[--ring:var(--primary)] max-sm:p-2",
    // Clear the home-indicator / notch on mobile so the action buttons aren't
    // flush against the bottom edge on notched devices.
    consentBannerCard:
      "border-border/60 shadow-lg max-sm:mb-[env(safe-area-inset-bottom)]",
    consentBannerDescription: "max-sm:text-[13px] max-sm:leading-[18px]",
    // Every action gets a 44px tap target (WCAG 2.5.5) at every width. On
    // mobile the buttons share one row, wrapping only on the narrowest phones.
    consentBannerFooter:
      "[&_button]:min-h-11 max-sm:flex-row max-sm:flex-wrap max-sm:gap-2 max-sm:px-3 max-sm:pt-0 max-sm:pb-3 max-sm:[&_button]:flex-auto max-sm:[&_button]:px-2.5",
    // Dissolve the two sub-groups so their buttons become one flex row.
    consentBannerFooterSubGroup: "max-sm:contents",
    consentBannerHeader: "max-sm:gap-0 max-sm:px-3 max-sm:pt-3 max-sm:pb-2",
    // The description already says what the banner is; the title stays in the
    // accessibility tree so the region keeps its name for screen readers.
    consentBannerTitle: "max-sm:sr-only",
    consentDialog: "[--ring:var(--primary)]",
    consentDialogCard: "border-border/60 shadow-xl",
  },
} satisfies Theme;
